import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipDetailMemberControllerModule } from './controllers/MembershipDetailMemberController';

export const MembershipDetailMemberView = angular
  .module('acme.view.application.membership.detail.member', [
    uiRouter,
    'ui.bootstrap',
    MembershipDetailMemberControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.membership.detail.member',
      url: '/:memberId/member',
      views: {
        'subview-main@application.membership': {
          controller: 'MembershipDetailMemberController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/detail/member/member.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Cardholder / Individual',
        permissions: ['MEMBERSHIP_CARD_VIEW'],
      },
      resolve: {
        MembershipData: ['MembershipData', (MembershipData) => MembershipData],
        SubscriptionData: ['SubscriptionData', (SubscriptionData) => SubscriptionData],
      },
    });
  }).name;
